import PropTypes from 'prop-types';
import React from 'react';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import WarningCircleIcon from '@mulesoft/anypoint-icons/lib/svg/error-filled.svg';
import CloseIcon from '@mulesoft/anypoint-icons/lib/svg/close-small.svg';
import * as eventHandlerUtils from '~/utils/eventHandlers';
import styles from './ScanCapacityBanner.css';

const ScanCapacityBanner = ({ isVisible, onClose }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={styles.scanCapacityBanner}
      data-test-id="scan-capacity-banner"
      role="banner"
    >
      <span className={styles.icon}>
        <Icon size="s">
          <WarningCircleIcon />
        </Icon>
      </span>
      <div className={styles.content}>
        <div className={styles.title} data-test-id="scan-capacity-banner-title">
          Scan capacity reached
        </div>
        <div
          className={styles.description}
          data-test-id="scan-capacity-banner-description"
        >
          Scheduled scans are paused until capacity is available. Ask your
          Salesforce admin to increase the capacity limit or remove some
          services.
        </div>
      </div>
      <span
        className={styles.close}
        data-test-id="scan-capacity-banner-close"
        onClick={onClose}
        role="button"
        tabIndex="0"
        aria-label="Close scan capacity banner"
        onKeyDown={eventHandlerUtils.onEnterKey(onClose)}
      >
        <Icon size="xs">
          <CloseIcon />
        </Icon>
      </span>
    </div>
  );
};

ScanCapacityBanner.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func
};

ScanCapacityBanner.defaultProps = {
  isVisible: false,
  onClose: () => {}
};

export default ScanCapacityBanner;
